module.exports = __webpack_public_path__ + "img/check.82997e30.svg";